let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("arAXd")).then(() => parcelRequire('040fA'));